import useShell from "@components/JMCHeader/useShell";
import useSiteReference from "@hooks/useSiteReference/useSiteReference";
import type { PageContext } from "@types";
import type { GatsbyImageProps } from "gatsby-plugin-image";
import { useEffect, useState } from "react";

interface LogoType {
    url: string;
    gatsbyImageData?: GatsbyImageProps;
}

const useLogo = (pageContext: PageContext, shouldAddProductTheme: boolean = false): LogoType => {
    const configuration = useShell();
    const siteReference = useSiteReference(pageContext);

    const [logo, setLogo] = useState<LogoType>(
        pageContext?.logo
            ? pageContext?.logo // used by tcp
            : shouldAddProductTheme
              ? siteReference()?.branding?.logo || siteReference()?.relation?.[0]?.productLogo || configuration?.logo
              : configuration?.logo
    );

    useEffect(() => {
        setLogo(
            pageContext?.logo
                ? pageContext?.logo //used for tcp
                : shouldAddProductTheme
                  ? siteReference()?.branding?.logo ||
                    siteReference()?.relation?.[0]?.productLogo ||
                    configuration?.logo
                  : configuration?.logo
        );
    }, [pageContext, shouldAddProductTheme, configuration, siteReference]);

    return logo;
};
export default useLogo;
